import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  output,
} from '@angular/core';

import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { SiaCheckBoxComponent } from '@sia/inputs';
import { SiaSearchBoxComponent, SiaTranslatePipe } from '@sia/shared';
import { SiaGridColConfig } from '../../interfaces/sia-grid-col-config';
import { SiaGridConfig } from '../../interfaces/sia-grid-config';
import { SiaMatGridConfiguratorColumnComponent } from '../sia-mat-grid-configurator-column/sia-mat-grid-configurator-column.component';

@Component({
  selector: 'sia-mat-grid-configurator-columns',
  templateUrl: './sia-mat-grid-configurator-columns.component.html',
  styleUrls: ['./sia-mat-grid-configurator-columns.component.scss'],
  standalone: true,
  imports: [
    MatIconButton,
    MatIcon,
    MatButton,
    SiaCheckBoxComponent,
    SiaMatGridConfiguratorColumnComponent,
    SiaTranslatePipe,
    MatInputModule,
    FormsModule,
    SiaSearchBoxComponent,
    DragDropModule,
  ],
})
export class SiaMatGridConfiguratorColumnsComponent {
  private cdr = inject(ChangeDetectorRef);

  private _gridConfiguration: SiaGridConfig = { group: {} };
  @Input() set gridConfiguration(value: SiaGridConfig) {
    this._gridConfiguration = value;
    this.selectedColumn = null;
    this.columns = this._gridConfiguration.cols;
    this.filterColumns();
  }
  @Input() dataBaseFields: { id: string; description: string }[] = [];
  get gridConfiguration(): SiaGridConfig {
    return this._gridConfiguration;
  }
  gridConfigurationChange = output<SiaGridConfig>();
  selectedColumn?: SiaGridColConfig | null;
  private columns?: SiaGridColConfig[];
  private _filter: string = '';
  public get filter(): string {
    return this._filter;
  }
  public set filter(value: string) {
    this._filter = value;
    this.filterColumns();
  }

  private filterColumns() {
    this.gridConfiguration.cols = this.columns;
    this.gridConfiguration.cols?.map((x) => {
      x.configurationVisible = this.filter
        ? ((x.caption?.toLowerCase().includes(this.filter.toLowerCase()) ||
            x.dataField?.toLowerCase().includes(this.filter.toLowerCase())) ??
          false)
        : true;
    });
    if (this.selectedColumn) {
      this.selectedColumn.selected = false;
      this.selectedColumn = null;
    }
  }

  addColumn() {
    if (!this.gridConfiguration.cols) {
      this.gridConfiguration.cols = [];
    }
    this.filter = '';
    this.gridConfiguration.cols?.unshift({
      caption: 'Nuova colonna',
      dataField: '',
      dataType: 'string',
      visible: true,
      sortOrder: 0,
      visibleIndex: 0,
      allowSorting: true,
      allowFilter: true,
      selected: true,
    });
    this.filterColumns();
    setTimeout(() => {
      this.selectColumn(this.gridConfiguration.cols?.[0] ?? {});
    }, 50);
  }

  sortVisibleColumns() {
    this.gridConfiguration.cols?.sort((a, b) => {
      if (!a.visible && b.visible) {
        return 1;
      }
      if (a.visible && !b.visible) {
        return -1;
      }
      return 0;
    });
    this.gridConfiguration.cols?.forEach((x, i) => (x.visibleIndex = i));
  }

  deleteColumn(col: SiaGridColConfig) {
    if (col.selected) {
      this.selectedColumn = null;
    }
    this.gridConfiguration.cols = this.gridConfiguration.cols?.filter(
      (x) => x !== col,
    );
    this.columns = this.columns?.filter((x) => x !== col);
    this.gridConfigurationChange.emit(this.gridConfiguration);
  }

  selectColumn(col: SiaGridColConfig) {
    this._gridConfiguration.cols?.forEach((x) => (x.selected = false));
    col.selected = true;
    if (!col.excelConfiguration) {
      col.excelConfiguration = {};
    }
    this.selectedColumn = col;
    this.cdr.detectChanges();
  }

  onColumnDrop(event: CdkDragDrop<any, any>) {
    if (!this.gridConfiguration.cols) {
      this.gridConfiguration.cols = [];
    }
    moveItemInArray(
      this.gridConfiguration.cols,
      event.previousIndex,
      event.currentIndex,
    );
    this.gridConfiguration.cols.forEach((x, i) => (x.visibleIndex = i));
  }
  translateAll() {
    this.gridConfiguration.cols?.forEach((col) => {
      if (col.dataType === 'string' && col.visible && !col.primaryKey) {
        col.translate = !col.translate;
      }
    });
  }
  exportAll() {
    this.gridConfiguration.cols?.forEach((col) => {
      if (col.visible && !col.isAction) {
        col.allowExporting = !col.allowExporting;
      }
    });
  }
  editAll() {
    this.gridConfiguration.cols?.forEach((col) => {
      if (col.visible && !col.isAction) {
        col.allowEditing = !col.allowEditing;
      }
    });
  }
}
